import { useEffect } from "react";
import { useRouter } from 'next/router';
import { ROUTES_REGEX_LIST } from '../utils/constants';
import { getPaths } from '../utils/helpers';
import { useLoopAuth } from '../components/auth-provider';
import { Loader } from "../design";
import useNavigationURL from "../hooks/useNavigationURL";

function Index() {

    const router = useRouter();

    const { isLoggedIn, user, authChecksCompleted } = useLoopAuth();
    const navigationUrl = useNavigationURL();

    const checkPath = async () => {
        const path: string = window.location.pathname;
        const { postProxy } = getPaths(path);

        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('sessionToken');

        if (postProxy == "get-subscription-link") {
            return router.push(`${navigationUrl}/get-subscription-link?${searchParams.toString()}`);
        }

        if (isLoggedIn) {
            for (let routeRegex of ROUTES_REGEX_LIST) {
                if (postProxy.match(routeRegex)) {
                    let _url = postProxy;
                    return router.push(`${_url}?${searchParams.toString()}`);
                }
            }
            return router.push(`${navigationUrl}/customer/${user.userShopifyId}?${searchParams.toString()}`);
        }
        return router.push(`${navigationUrl}/get-subscription-link?${searchParams.toString()}`);
    }

    useEffect(() => {
        if (router.isReady && authChecksCompleted) {
            checkPath();
        }
    }, [router, authChecksCompleted]);

    if (!router.isReady || !authChecksCompleted) {
        <>
            <Loader />
        </>
    }

    return (
        <>
        </>
    );
}

export default Index;
